import { useMutation, useQueryClient } from 'react-query';
import { personKeys } from '../cache-keys/personKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { insurance_api } from '@axo/shared/data-access/api';

export function useTerminateInsurance() {
  const api = useAPI();
  const client = useQueryClient();
  return useMutation(insurance_api.terminateInsurance(api), {
    onSuccess: (result) =>
      client.invalidateQueries(
        personKeys.insurance({
          personID: result.PersonID,
        })
      ),
  });
}
